import React from 'react';
import { Row, Col, Button, Input, Spinner } from 'reactstrap';

const SupportDocs = ({
  documents = [],
  isLoading,
  searchText,
  onSearchChange,
  onClearSearch,
  showDmutBadge = false,
}) => {
  const openDocument = url => {
    if (!url) return;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <Row>
      <Col xs={12}>
        <div className='d-flex gap-3 mb-4'>
          <div className='position-relative' style={{ width: '250px' }}>
            <i className='ri-search-line position-absolute top-50 start-0 translate-middle-y ms-3 text-muted'></i>
            <Input
              type='text'
              placeholder='Search...'
              className='ps-5'
              value={searchText}
              onChange={e => onSearchChange?.(e.target.value)}
            />
          </div>
          <Button
            color='danger'
            outline
            className='bg-white fw-medium'
            onClick={onClearSearch}
            disabled={!searchText}
          >
            Clear Filter
          </Button>
        </div>

        {isLoading ? (
          <div className='text-center py-4'>
            <Spinner size='sm' color='primary' />
            <p className='text-muted small mt-2 mb-0'>Loading documents...</p>
          </div>
        ) : documents.length === 0 ? (
          <p className='text-muted small mb-0'>No documents available.</p>
        ) : (
          documents.map(doc => (
            <div
              key={doc.id}
              className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3'
            >
              <div className='d-flex align-items-center gap-3'>
                <div
                  className='bg-light rounded d-flex align-items-center justify-content-center'
                  style={{ width: '48px', height: '48px' }}
                >
                  <i
                    className={`${
                      doc.isMasterDocument
                        ? 'ri-file-text-fill text-success'
                        : 'ri-file-text-fill text-primary'
                    } fs-3`}
                  ></i>
                </div>
                <div>
                  <h6 className='fw-medium text-dark mb-1'>
                    {doc.documentName || doc.customFileName || '-'}
                  </h6>
                  <div className='d-flex align-items-center gap-2 small'>
                    <span
                      className={`badge ${
                        doc.isMasterDocument
                          ? 'bg-success-subtle text-success'
                          : 'bg-primary-subtle text-primary'
                      }`}
                    >
                      {doc.isMasterDocument
                        ? 'Master Document'
                        : 'Upload Custom'}
                    </span>
                    {(doc.lastUpdated || doc.createdDate) && (
                      <span className='text-muted'>
                        {doc.lastUpdated
                          ? `Updated: ${doc.lastUpdated}`
                          : `Created: ${doc.createdDate}`}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className='d-flex align-items-center justify-content-between gap-4'>
                {showDmutBadge && doc.isShowToDMUT && (
                  <span className='small text-dark fw-medium d-inline-flex align-items-center gap-1'>
                    <span className='text-danger'>*</span> Show to DMUT
                  </span>
                )}
                <Button
                  color='light'
                  className='border bg-white text-dark rounded-3 fw-medium px-4'
                  onClick={() => openDocument(doc.actualUrl)}
                  disabled={!doc.actualUrl}
                >
                  View
                </Button>
              </div>
            </div>
          ))
        )}
      </Col>
    </Row>
  );
};

export default SupportDocs;
